import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import gsap from "gsap";
import { db } from "../firebase";
import { collection, addDoc, doc, onSnapshot } from "firebase/firestore";

//SVG
import { ReactComponent as Plus } from "../assets/plus.svg";
import { ReactComponent as Minus } from "../assets/minus.svg";
import { ReactComponent as ShoppingCart } from "../assets/shoppingcart.svg";
import { ReactComponent as Close } from "../assets/close.svg";

export default function Cart(props) {
  const { cartItems, onAdd, onRemove, useClickOutside } = props;

  const deliveryPrice = 150;

  const itemsPrice = cartItems.reduce((a, c) => a + c.qty * c.price, 0);
  const totalPrice = itemsPrice + deliveryPrice;

  const [showCart, setShowCart] = useState(false);

  const handleToggleCart = () => {
    if (isWaiting) return; // Prevent closing cart while waiting
    setShowCart(!showCart);
  };

  //Radio button
  const [formData, setFormData] = useState({
    isAgree: false,
    payment: "Кеш",
  });
  const handleChange = (event) => {
    const target = event.target;
    const name = target.name;
    const value = target.value;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  //Outside Click
  const domNode = useClickOutside(() => {
    setShowCart(false);
  });

  const [status, setStatus] = useState("Поручи");

  const [notice, setNotice] = useState(null);

  const [orderId, setOrderId] = useState(null);

  const [isWaiting, setIsWaiting] = useState(false);

  const [showOverlay, setShowOverlay] = useState(false);

  const [noticeStatus, setNoticeStatus] = useState(""); // '', 'accepted', 'rejected'

  useEffect(() => {
    if (orderId) {
      const unsubscribe = onSnapshot(doc(db, "orders", orderId), (docSnap) => {
        if (docSnap.exists()) {
          const data = docSnap.data();
          if (data.status === "accepted") {
            setNotice(
              `Ваша поруџбина је прихваћена \r\n Време доставе ${data.deliveryTime ? data.deliveryTime + " мин" : "45-50 мин"}`,
            );
            setStatus("Поручи");
            setIsWaiting(false);
            setOrderId(null);
            setNoticeStatus("accepted");
            window.onbeforeunload = null; // Remove warning
            gsap.to(".notice", {
              opacity: 1,
            });
            gsap.to(".notice", { opacity: 0, duration: 0.5, delay: 4 });
            gsap.to(".productOverlay", {
              opacity: 0,
              duration: 0.5,
              delay: 4,
              onComplete: () => setShowOverlay(false),
            });
          } else if (data.status === "rejected") {
            setNotice(data.rejectReason || "Поруџбина је одбијена");
            setStatus("Поручи");
            setIsWaiting(false);
            setOrderId(null);
            setNoticeStatus("rejected");
            window.onbeforeunload = null; // Remove warning
            gsap.to(".notice", {
              opacity: 1,
            });
            gsap.to(".notice", { opacity: 0, duration: 0.5, delay: 4 });
            gsap.to(".productOverlay", {
              opacity: 0,
              duration: 0.5,
              delay: 4,
              onComplete: () => setShowOverlay(false),
            });
          }
        }
      });
      return unsubscribe;
    }
  }, [orderId]);

  useEffect(() => {
    if (isWaiting) {
      window.onbeforeunload = () =>
        "Чека се одговор од куvara. Молимо не напуштајте страницу.";
    } else {
      window.onbeforeunload = null;
    }
    return () => {
      window.onbeforeunload = null;
    };
  }, [isWaiting]);

  const product = cartItems
    .map(
      (item) =>
        item.qty +
        " x " +
        item.name +
        " " +
        (!!item.subtitle ? item.subtitle : ""),
    )
    .join("\r\n");

  const itemprice = cartItems.map((item) => item.price + " рсд").join("\r\n");

  async function sendEmail(e) {
    e.preventDefault();
    setStatus("Поруџбина се шаље");
    try {
      const docRef = await addDoc(collection(db, "orders"), {
        name: e.target.name.value,
        phone: e.target.phone.value,
        street: e.target.street.value,
        floor: e.target.floor.value,
        notice: e.target["notice-msg"].value,
        payment: formData.payment,
        products: product,
        itemPrices: itemprice,
        totalPrice: totalPrice,
        cartItems: cartItems,
        deliveryPrice: deliveryPrice,
        itemsPrice: itemsPrice,
        status: "pending",
        timestamp: new Date(),
      });
      setOrderId(docRef.id);
      setIsWaiting(true);
      setNotice("Чека се прихватање поруџбине...");
      setStatus("Чека прихватање");
      setNoticeStatus("");
      setShowCart(false); // Close cart modal
      gsap.to(".notice", {
        opacity: 1,
      });
      setShowOverlay(true);
    } catch (error) {
      setNotice("Грешка у слању");
      setStatus("Поручи");
      gsap.to(".notice", {
        opacity: 1,
        delay: 1,
      });
      gsap.from(".notice", {
        opacity: 0,
        delay: 4,
      });
    }
    e.target.reset();
    setTimeout(() => {
      cartItems.length = 0;
    }, 450);
    localStorage.removeItem("cartItems");
  }

  return (
    <>
      <button
        className={`shopping-cart-button ${cartItems.length > 0 ? "active" : ""}`}
        onClick={() => handleToggleCart()}
      >
        <ShoppingCart />
        <motion.span
          className={`cart-notice ${cartItems.length > 0 ? "active" : ""}`}
        >
          {cartItems.length}
        </motion.span>
      </button>

      <div className={`cart${showCart ? " open" : ""}`} ref={domNode}>
        <span className="close" onClick={() => setShowCart(false)}>
          <Close />
        </span>
        {cartItems.length === 0 && (
          <div className="shopping-cart-title empty">Корпа је празна</div>
        )}
        {cartItems.length !== 0 && (
          <div className="shopping-cart-title">Ваша поруџбина</div>
        )}

        <form onSubmit={sendEmail}>
          {cartItems.map((item) => (
            <div key={item.id} className="cart-row">
              <span className="cart-title">{item.name}</span>
              <span className="cart-buttons">
                <span
                  onClick={() => onRemove(item)}
                  className="remove"
                  style={{
                    pointerEvents: isWaiting ? "none" : "auto",
                    opacity: isWaiting ? 0.5 : 1,
                  }}
                >
                  <Minus />
                </span>
                <span className="cart-buttons-qty">{item.qty}</span>
                <span
                  onClick={() => onAdd(item)}
                  className="add"
                  style={{
                    pointerEvents: isWaiting ? "none" : "auto",
                    opacity: isWaiting ? 0.5 : 1,
                  }}
                >
                  <Plus />
                </span>
              </span>

              <span className="cart-item-price summery">
                {item.price * item.qty} рсд
              </span>
            </div>
          ))}
          {cartItems.length !== 0 && (
            <>
              <div className="cart-row">
                <span className="cart-title total">Достава</span>
                <span className="cart-price">{deliveryPrice} рсд</span>
              </div>
              <div className="cart-row">
                <span className="cart-title total">Укупно</span>
                <span className="cart-price">{totalPrice} рсд</span>
              </div>
              <div className="cart-inputs">
                <div className="input-invisible">
                  <textarea
                    type="text"
                    id="product"
                    name="product"
                    value={product}
                    readOnly
                    required
                  />
                  <textarea
                    type="text"
                    id="itemprice"
                    name="itemprice"
                    value={itemprice}
                    readOnly
                    required
                  />
                  <input
                    type="text"
                    id="totalprice"
                    name="totalprice"
                    value={totalPrice}
                    readOnly
                    required
                  />
                </div>

                <div className="cart-inputs-row">
                  <div>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      placeholder="Ваше име"
                      required
                    />
                  </div>
                  <div>
                    <input
                      type="number"
                      id="phone"
                      name="phone"
                      placeholder="Телефон"
                      required
                    />
                  </div>
                </div>
                <div className="cart-inputs-row">
                  <div>
                    <input
                      type="text"
                      id="street"
                      name="street"
                      placeholder="Адреса"
                      required
                    />
                  </div>
                  <div>
                    <input
                      type="text"
                      id="floor"
                      name="floor"
                      placeholder="Спрат / број стана"
                    />
                  </div>
                </div>

                <div className="notice-msg">
                  <div className="shopping-cart-title">Напомена</div>
                  <textarea
                    type="text"
                    id="notice-msg"
                    name="notice-msg"
                    rows="4"
                    cols="50"
                  />
                </div>

                <div className="payment">
                  <div className="shopping-cart-title">Начин плаћања</div>
                  <div>
                    <div>
                      <input
                        type="radio"
                        id="payment-cash"
                        name="payment"
                        value="Кеш"
                        onChange={handleChange}
                        checked={formData.payment === "Кеш"}
                      />
                      <label htmlFor="payment-cash">Кеш</label>
                    </div>
                    <div>
                      <input
                        type="radio"
                        id="payment-card"
                        name="payment"
                        value="Картица"
                        onChange={handleChange}
                        checked={formData.payment === "Картица"}
                      />
                      <label htmlFor="payment-card">Картица</label>
                    </div>
                  </div>
                </div>
              </div>
              <div className="cart-row min-span">
                {totalPrice < 750 ? (
                  <span data-hover="Минимална цена је 600 дин">
                    Минимална цена је 600 дин
                  </span>
                ) : (
                  <button
                    className="cart-checkout fancy-link"
                    type="submit"
                    disabled={isWaiting}
                  >
                    <span data-hover={status}>{status}</span>
                  </button>
                )}
              </div>
            </>
          )}
        </form>
      </div>

      {showOverlay && <div className="productOverlay"></div>}

      <div
        className="notice"
        style={
          noticeStatus === "rejected"
            ? { background: "#d32f2f", color: "white" }
            : {}
        }
      >
        {isWaiting && <div className="spinner"></div>}
        {notice}
      </div>
      {showCart ? (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.2 }}
          className="productOverlay"
        ></motion.div>
      ) : null}
    </>
  );
}
